const handleDropdownMaterialOptions = () => {
	const $dropdownOptions = $('.js-dropdown-material-options');
	const $dropdownTriggerImage = $dropdownOptions.find('.dropdown__trigger-image');
	const $dropdownTriggerTitle = $dropdownOptions.find('.dropdown__trigger-content h4');

	$dropdownOptions.find('input').on('change', function() {
		const $this = $(this);

		if ($this.prop('checked') === true) {
			$dropdownTriggerImage.html('');

			$this.siblings().find('.dropdown__radio-image img').clone().appendTo($dropdownTriggerImage);

			$dropdownTriggerTitle.text($this.siblings().find('.dropdown__radio-content h4').text());

			// Change material tab entry
			$('.js-material-tab[data-material-tab="' + $this.closest('.dropdown__radio').data('material') + '"]').removeClass('hidden').siblings().addClass('hidden');
		}
	});
}

handleDropdownMaterialOptions();
